<template>
  <div class="home">
    <navbar></navbar>
    <div class="box">
      <h1>Production Units</h1>
      <p>Production units are isolated cloud broadcast production environments.</p>
      <loading v-if="loading"></loading>
      <div v-else class="grid-2 has-gutter">
        <div class="production-unit" v-for="unit in productionUnits" :key="unit.id">
          <div class="info">
            <div class="name">{{ unit.name }}</div>
            <div class="description">{{ unit.description }}</div>
          </div>
          <div class="access">
            <button @click="goTo(unit.id)">Access</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Navbar from '@/components/Navbar';
import Loading from '@/components/Loading';
import OBWanServices from '@/utils/obwan-services';

export default {
  name: 'home',
  components: { Navbar, Loading },
  data () {
    return {
      loading: true,
      productionUnits: null
    }
  },
  methods:{
    goTo(id) {
      this.$router.push({ name: 'productionUnit', params: { id }})
    }
  },
  mounted () {
    OBWanServices.getProductionUnits().then(productionUnits => {
      this.productionUnits = productionUnits;
      this.loading = false;
    });
  }
}
</script>
<style lang="scss" scoped>
 .box {
    background-color: #393C44;
    border: 1px solid #4B505C;
    border-radius: 5px;
    padding: 5px 8vw 20px 8vw;
    min-height: calc(100vh - 170px);
 }
 p{
   margin-bottom: 25px;
 }
 .production-unit {
    background: #525660;
    box-shadow: 0 2px 0 0 #23252A;
    border-radius: 4px;
    width: calc(100% - 10px);
    min-height: 50px;
    position: relative;
    padding: 10px 0 0 10px;

    .info {
      .name {
        font-size: 18px;
        font-weight: 600;
      }
      .description {
        font-size: 12px;
      }
    }
    .access {
      position: absolute;
      top: 10px;
      right: 10px;
    }
 }
</style>
